import { Route, RouteGroup } from '@billow/easy-route'
import { concat } from 'lodash'

export default concat(

  RouteGroup({
    middleware: ['auth', 'active-subscriber'],
    routes: [
      Route('/app', 'create-app', () => import('@/views/apps/Create.vue')),
      Route('/apps', 'apps', () => import('@/views/apps/Index.vue')),
      Route('/app-keys', 'app-setup-keys', () => import('@/views/apps/SetupKeys.vue')),
    ]
  }),
  
  RouteGroup({

    middleware: ['auth', 'active-subscriber'],

    parent: Route('/apps/:app', '', () => import('@/views/apps/Manager/Manager.vue')),

    routes: [
      Route('/', 'app-manager', () => import('@/views/apps/Manager/Overview.vue')),
      Route('settings', 'app-settings', () => import('@/views/apps/Manager/Settings.vue')),
      Route('audits', 'app-audits', () => import('@/views/apps/Manager/Audits.vue')),
      Route('environments', 'app-environments', () => import('@/views/apps/Manager/Environments.vue')),
      Route('team', 'app-team', () => import('@/views/apps/Manager/Team.vue')),
      Route('reporting', 'app-reporting', () => import('@/views/apps/Manager/Reporting.vue')),
      Route('environment', 'new-app-environment', () => import('@/views/apps/Manager/CreateEnvironment.vue')),
    ]
  })
)